import React from 'react';
import { Layout, Row, Col, Space, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Footer } = Layout;
const { Text } = Typography;

const SiteFooter: React.FC = () => {
  const { t, i18n } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <Footer style={{ background: '#fff', borderTop: '1px solid #f0f0f0' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '24px 16px' }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={8}>
            <Space direction="vertical" size={8}>
              <Text strong>LuxEthics</Text>
              <Text type="secondary">{t('footer.slogan')}</Text>
            </Space>
          </Col>
          <Col xs={24} md={8}>
            <Space direction="vertical" size={8}>
              <Text strong>{t('footer.links')}</Text>
              <Link to="/about">{t('footer.about')}</Link>
              <Link to="/brands">{t('footer.browse_brands')}</Link>
              <Link to="/world-map">{t('footer.world_map')}</Link>
              <Link to="/privacy">{t('footer.privacy_policy')}</Link>
              <Link to="/terms">{t('footer.terms_of_use')}</Link>
            </Space>
          </Col>
          <Col xs={24} md={8}>
            <Space direction="vertical" size={8}>
              <Text strong>{t('footer.legal')}</Text>
              <Text type="secondary">{t('footer.disclaimer')}</Text>
              <Text>
                {t('footer.contact_email_label')}:
                <a href="mailto:9600348@qq.com">9600348@qq.com</a>
              </Text>
            </Space>
          </Col>
        </Row>
        <div style={{ marginTop: 16, textAlign: 'center', color: '#999' }}>
          © {year} LuxEthics · {t('footer.rights_reserved')}
        </div>
      </div>
    </Footer>
  );
};

export default SiteFooter;
